module.exports = __webpack_public_path__ + "static/media/option9-4row.e6071571.png";